import { Head } from '@inertiajs/react'
import { useEffect } from "react"
import { usePage, Link } from "@inertiajs/react"
import api from "@/api"
import { Button } from "@/components/ui/button"


export default function Show({ customer_session, pricing_table_id, publishable_key }) {
  const { organization } = usePage().props.auth
  useEffect(() => {
    const id = "stripe-pricing-table-js"
    if (!document.getElementById(id)) {
      const script = document.createElement("script")
      script.id = id
      script.async = true
      script.src = "https://js.stripe.com/v3/pricing-table.js"
      document.body.appendChild(script)
    }
  }, [])

  return (
    <>
      <Head>
        <title>founder/mode | Upgrade</title>
      </Head>
      <div className="p-10">
        <div className="flex flex-col gap-6 max-w-5xl mx-auto">
          <h1 className="text-2xl font-bold text-center">Choose your plan</h1>
          <p className="text-center text-muted-foreground">
            Flexible pricing for founders at all stages of their journey.
          </p>
          <div className="bg-background rounded-lg p-4">
            <stripe-pricing-table
              pricing-table-id={pricing_table_id}
              publishable-key={publishable_key}
              customer-session-client-secret={customer_session.client_secret}>
            </stripe-pricing-table>
          </div>
          <div className="text-center">
            <Button variant="ghost" asChild>
              <Link href={api.organizationsDashboard.show.path({ org_nano_id: organization.nano_id })}>
                Continue for free
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}


